import LangEnum from '../../../../../../../../../lang/LangEnum';
import { useUpdateCatalog } from '../../../../../../../../../services/modules/catalogs/catalogs.mutations';
import { AvailabilityEnum } from '../../../../../../../../products/ProductTypes';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';
import { MIN_AVAILABILITY_CONDITION_VALUE } from '../../../../../../../creation/catalogCreationForm.schema';
import { parseStockConditionInputValue } from '../../../../../../../creation/catalogCreationStock.utils';
import { formattedAvailabilityConditions } from '../../../../../../../utils/availabilityConditions.utils';
import { CatalogGridCriteriaSectionProps } from '../CatalogGridCriteriaSection';
import { StockConditionField } from '../catalogGridCriteriaSection.types';

interface SubmitStockConditionParams {
  availability: AvailabilityEnum;
  field: StockConditionField;
  value: string;
}

const useCatalogGridCriteriaSection = ({
  id,
  isReadOnly,
  availabilityConditions,
}: CatalogGridCriteriaSectionProps) => {
  const { translate } = useTranslation();
  const { mutate } = useUpdateCatalog({ catalogId: id });

  const validateStockCondition = (value: string) => {
    const parsedValue = parseStockConditionInputValue(value);

    if (parsedValue === null) {
      return undefined;
    }

    if (!Number.isInteger(parsedValue) || parsedValue > Number.MAX_SAFE_INTEGER) {
      return translate(LangEnum.GLOBAL_INVALID_NUMBER);
    }

    if (parsedValue < MIN_AVAILABILITY_CONDITION_VALUE) {
      return translate(LangEnum.GLOBAL_VALUE_MUST_BE_GREATER_THAN_OR_EQUAL, {
        value: MIN_AVAILABILITY_CONDITION_VALUE,
      });
    }

    return undefined;
  };

  const submitStockCondition = ({ availability, field, value }: SubmitStockConditionParams) => {
    const nextConditions = {
      ...availabilityConditions,
      [availability]: {
        ...availabilityConditions?.[availability],
        [field]: parseStockConditionInputValue(value) ?? undefined,
      },
    };

    mutate({ availabilityConditions: formattedAvailabilityConditions(nextConditions) });
  };

  return {
    isFieldDisabled: isReadOnly,
    validateStockCondition,
    submitStockCondition,
  };
};

export default useCatalogGridCriteriaSection;
